module.exports = __webpack_public_path__ + "img/yape-lg.0d965c59.png";